import { createSlice } from '@reduxjs/toolkit';

/**
 * A slice for managing the state of "turno" (shift) in the application.
 *
 * @namespace TurnoSlice
 * @property {Array} initialState.turnos_list - List of shifts.
 * @property {Object} initialState.turno - Current shift.
 * @property {boolean} initialState.days - Flag indicating if there is an error with days.
 *
 * @function setTurnosRedux
 * @description Sets the list of shifts.
 * @param {Object} state - The current state.
 * @param {Object} action - The action object containing the payload.
 * @param {Array} action.payload - The new list of shifts.
 *
 * @function storeTurnosRedux
 * @description Stores the current shift.
 * @param {Object} state - The current state.
 * @param {Object} action - The action object containing the payload.
 * @param {Object} action.payload - The new current shift.
 *
 * @function showDaysErrorRedux
 * @description Sets the days error flag to true.
 * @param {Object} state - The current state.
 *
 * @function hideDaysErrorRedux
 * @description Sets the days error flag to false.
 * @param {Object} state - The current state.
 *
 * @function storeTurnoRedux
 * @description Stores the current shift (duplicate of storeTurnosRedux).
 * @param {Object} state - The current state.
 * @param {Object} action - The action object containing the payload.
 * @param {Object} action.payload - The new current shift.
 */
export const TurnoSlice = createSlice({
  name: 'turno',
  initialState: {
    turnos_list: [],
    turnos_select_list: [],
    turno: {},
    days: false,
  },
  reducers: {
    setTurnosRedux: (state, { payload }) => {
      state.turnos_list = payload;
    },
    storeTurnosRedux: (state, { payload }) => {
      state.turno = payload;
    },
    showDaysErrorRedux: (state) => {
      state.days = true;
    },
    hideDaysErrorRedux: (state) => {
      state.days = false;
    },
    storeTurnoRedux: (state, { payload }) => {
      state.turno = payload;
    },
    setShiftsSelectRedux: (state, { payload }) => {
      state.turnos_select_list = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setTurnosRedux,
  storeTurnosRedux,
  showDaysErrorRedux,
  hideDaysErrorRedux,
  storeTurnoRedux,
  setShiftsSelectRedux,
} = TurnoSlice.actions;
